import { Injectable } from '@angular/core';

export abstract class VisibilityController {
  isFieldVisible: boolean;
  abstract handleShowFieldIconClicked();
  abstract handleHideFieldIconClicked();
  abstract handleUserInput(event: MouseEvent);
}

@Injectable()
export class DefaultVisibilityController implements VisibilityController {
  isFieldVisible = false;
  handleShowFieldIconClicked() {
    this.isFieldVisible = true;
  }
  handleHideFieldIconClicked() {
    this.isFieldVisible = false;
  }
  handleUserInput(event: MouseEvent) {
    // Noop
  }
}
